<template>
  <div class="opportunity-panel-header">
    <fluent-icon
      icon="filter"
      size="20"
      class="opportunity-panel-header__icon"
    />
    <h3 class="sub-block-title opportunity-panel-header__title">
      <slot />
    </h3>
    <woot-button
      icon="dismiss"
      class="close-button--rtl opportunity-panel-header__close"
      type="button"
      :title="closeLabel"
      @click="$emit('close')"
    />
  </div>
</template>

<script>
export default {
  name: 'OpportunityPanelHeader',
  props: {
    closeLabel: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.opportunity-panel-header {
  align-items: center;
  background-color: #053ca8;
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  min-height: var(--space-larger);
  padding: var(--space-small) var(--space-larger);
  position: relative;
}

.opportunity-panel-header__icon {
  color: var(--b-50);
  left: var(--space-normal);
  position: absolute;
}

.opportunity-panel-header__title {
  color: var(--b-50);
  margin: 0;
  overflow-wrap: break-word;
  text-align: center;
  width: 100%;
}

.opportunity-panel-header__close {
  background: transparent;
  height: auto;
  position: absolute;
  right: var(--space-small);
  top: var(--space-small);
  width: auto;

  &:hover {
    background-color: transparent;
    color: var(--white-transparent);
  }
}
</style>
